
(function ($: JQueryStatic) {

    addMethod("nottenantbic", value => basePath + `api/checknottenantbic?p_bic=${value}`, true, false);

    $.validator.addMethod('fractions', (p_value, p_element, p_params) => {
        var elemValStr = p_value.replace(",", ".");
        var elemVal = parseFloat(elemValStr);

        if (p_params >= 1)
            return true;

        if (elemVal != parseFloat(p_params))
            return false;

        return true;
    });
    (<any>$.validator).unobtrusive.adapters.addBool('fractions');

    $.validator.addMethod('ibanRequired', (p_value, p_element, p_params) => {
        if (p_element.attributes.getNamedItem("data-rule-ibanRequired") == null)
            return true;

        return p_value.trim() !== '';
    });
    (<any>$.validator).unobtrusive.adapters.addBool('ibanRequired');

    $.validator.addMethod('depot', (p_value, p_element, p_params) => {
        //Bei komplexer Prüfung ggf. Gemeinsamkeiten der Validierung in separate TS Klasse auslagern
        if (p_value.length < 1)
            return true;
        return p_value === "BASIS";
    });
    (<any>$.validator).unobtrusive.adapters.addBool('depot');

    $.validator.addMethod("date",
        function (p_value, p_element) {
            var isValid = false;

            if (!p_value)
                return false;

            var dateParts = p_value.toString().split("-", 3);
            if (dateParts.length < 3)
                return false;

            // Check if month and day include leading zeros (needed for IE)
            var month = dateParts[1];
            var day = dateParts[2].replace(".", "");
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            var dateStr = dateParts[0] + "-" + month + "-" + day;

            // Create a new date object with the selected
            // year, month, and day values and retrieve the
            // milliseconds from it.
            var localDate = new Date(dateStr);
            var localOffset = localDate.getTimezoneOffset() * 60000;
            var mSeconds = localDate.getTime() + localOffset;
            var objDate = new Date();

            // Set the time of the object to the milliseconds 
            // retrieved from the original date. This will
            // convert it to a valid date.
            objDate.setTime(mSeconds);

            var dayOfDate = objDate.getDate();
            var dayString = objDate.getDate().toString();

            if (dayOfDate < 10)
                dayString = "0" + dayString;
            // Compare if the date has changed, if it has then
            // the date is not valid 
            if (objDate.getFullYear().toString() === dateParts[0] &&
                (objDate.getMonth() + 1).toString() === dateParts[1] &&
                dayString === day) {
                if (objDate <= new Date() && objDate > new Date("1753-01-01")) {
                    isValid = true;
                }
            }
            return isValid;
        });
    (<any>$.validator).unobtrusive.adapters.addBool('date');

    $.validator.addMethod("transferdate",
        function (p_value, p_element) {
            var isValid = false;

            var dateParts = p_value.toString().split("-", 3);
            if (dateParts.length < 3)
                return false;

            // Check if month and day include leading zeros (needed for IE)
            var month = dateParts[1];
            var day = dateParts[2].replace(".", "");
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            var dateStr = dateParts[0] + "-" + month + "-" + day;

            // Create a new date object with the selected
            // year, month, and day values and retrieve the
            // milliseconds from it.
            var localDate = new Date(dateStr);
            var localOffset = localDate.getTimezoneOffset() * 60000;
            var mSeconds = localDate.getTime() + localOffset;
            var objDate = new Date();

            // Set the time of the object to the milliseconds 
            // retrieved from the original date. This will
            // convert it to a valid date.
            objDate.setTime(mSeconds);

            var dayOfDate = objDate.getDate();
            var dayString = objDate.getDate().toString();

            if (dayOfDate < 10)
                dayString = "0" + dayString;
            // Compare if the date has changed, if it has then
            // the date is not valid 
            if (objDate.getFullYear().toString() === dateParts[0] &&
                (objDate.getMonth() + 1).toString() === dateParts[1] &&
                dayString === day) {
                if (objDate > new Date() && objDate < new Date("2099-01-01")) {
                    isValid = true;
                }
            }
            return isValid;
        });
    (<any>$.validator).unobtrusive.adapters.addBool('transferdate');

    let isValidDate: (p_dateString: string) => boolean = (p_dateString: string) => {
        let strictDateFormatParsing: boolean = true;

        let mom = moment(p_dateString, "YYYY-M-D", strictDateFormatParsing);

        if (!mom.isValid())
            return false;

        if (mom.isBefore(moment('1753-01-01')))
            return false;

        return true;
    }

    $.validator.addMethod('daterequired', (p_value: any, p_element: HTMLElement) => {
        return isValidDate(p_value);
    });
    (<any>$.validator).unobtrusive.adapters.addBool('daterequired')
    $.validator.addMethod('optionaldate', (p_value: any, p_element: HTMLElement) => {
        if (!p_value || (<string>p_value).length === 0)
            return true;

        return isValidDate(p_value);
    });
    (<any>$.validator).unobtrusive.adapters.addBool('optionaldate');

    $.validator.addMethod("dateinfuture", (p_value: any, p_element: HTMLElement) => {
        if (!p_value || (<string>p_value).length === 0)
            return true;

        if (!isValidDate(p_value))
            return false;

        if (moment(p_value).isBefore(moment({ h: 0, m: 0, s: 0, ms: 0 })))
            return false;

        return true;
    });
    (<any>$.validator).unobtrusive.adapters.addBool('dateinfuture');

    $.validator.addMethod('required-client', (p_value, p_element, p_params) => {
        //return $.validator.methods["required"](p_value, p_element, p_params).bind(this);
        return (typeof (p_value) != "undefined" && p_value != null && p_value.length > 0)
    });
    (<any>$.validator).unobtrusive.adapters.addBool('required-client');

    $.validator.addMethod('mustbetrue', (p_value, p_element, p_params) => {
        return p_value === "true";
    });
    (<any>$.validator).unobtrusive.adapters.addBool('mustbetrue');

    $.validator.addMethod("notDefaultText", function (p_value, p_element) {
        if (p_value === $(p_element).attr('placeholder')) {
            return false;
        } else {
            return true;
        }
    });
    (<any>$.validator).unobtrusive.adapters.addBool('notDefaultText');

    $.validator.addMethod("floatMin", function (p_value, p_element, p_params) {
        var elemValStr = p_value.replace(",", ".");
        var elemVal = parseFloat(elemValStr);
        if (elemVal == 0)
            return false;

        if (elemVal === NaN || p_params > elemVal) {
            return false;
        } else {
            return true;
        }
    });
    (<any>$.validator).unobtrusive.adapters.addBool('floatMin');

    $.validator.addMethod("floatMax", function (p_value, p_element, p_params) {
        var elemValStr = p_value.replace(",", ".");
        var elemVal = parseFloat(elemValStr);
        if (elemVal === NaN || elemVal > p_params) {
            return false;
        } else {
            return true;
        }
    });
    (<any>$.validator).unobtrusive.adapters.addBool('floatMax');

    $.validator.addMethod("krypto-isin", function (value, element, params) {
        if (typeof value === "string") {
            value = value.trim();
        }

        if (this.optional(element)) {
            return true;
        }

        var pattern = /^XX00000000(?:0[1-9]|1\d|2[0-6])$/;
        return !pattern.test(value);
    });

    (<any>$.validator).unobtrusive.adapters.addBool("krypto-isin");




    function addMethod(p_methodName, p_urlBuilder: (value: string) => string, p_useCache, p_required) {
        $.validator.addMethod(p_methodName,
            function (p_value, p_element) {

                if (!p_required && p_value == "")
                    return true;

                var response;

                notifier.DisableAjaxCompleteNotifier++;

                $.ajax({
                    context: this,
                    async: false,
                    cache: p_useCache,
                    type: "GET",
                    url: p_urlBuilder(p_value),
                    dataType: "JSON",
                    success: function (p_result) {
                        this.response = p_result;
                    },
                    error: function (p_jqXHR, p_textStatus, p_errorThrown) {
                        this.response = false;
                    }
                });
                notifier.DisableAjaxCompleteNotifier--;
                return this.response;
            });
        (<any>$.validator).unobtrusive.adapters.addBool(p_methodName);
    };
    addMethod("iban", value => `${basePath}api/checkiban/${value}?blz=${$('#ToBlz').val().trim()}`, true, false);
    addMethod("ibansyntax", value => basePath + 'api/checkibansyntax/' + value, true, false);
    addMethod("blz", value => basePath + "api/checkblz?p_blz=" + value, true, true);
    addMethod("toblz", value => basePath + "api/checktenantblz?p_blz=" + value, true, true);
    addMethod("taxid", value => basePath + "api/checktaxid/" + value, true, false);
    addMethod("depotnumber", value => `${basePath}api/checkdepotnumber/${value}?blz=${$('#ToBlz').val().trim()}`, true, true);
    addMethod("signature", value => basePath + "api/checksignature/" + value, false, true);
    addMethod("filialnumber", value => basePath + "api/checkfilialnumber/" + value, false, true);
    addMethod("nottendantblz", value => basePath + "api/checknottenantblz?p_blz=" + value, true, false);


    // extend range validator method to treat checkboxes differently
    var defaultRangeValidator = (<any>$.validator).methods.range;
    (<any>$.validator).methods.range = function (value, element, param) {
        if (element.type === 'checkbox') {
            // if it's a checkbox return true if it is checked
            return element.checked;
        } else {
            // otherwise run the default validation function
            return defaultRangeValidator.call(this, value, element, param);
        }
    };

    var baseRequired = $.validator.methods["required"];
    $.validator.methods["required"] = function (p_value, p_element, p_params) {
        return baseRequired.apply(this, [$.trim(p_value), p_element, p_params]);
    }
    var baseEmailValidator = $.validator.methods['email']
    $.validator.methods['email'] = function (p_value, p_element, p_params) {
        var isEmailHtmlValid = baseEmailValidator.apply(this, arguments);
        if (!isEmailHtmlValid)
            return false;

        if (p_value.length === 0)
            return true;

        var regex = /.*@.+\..+/
        return regex.test(p_value);
    }

    $.validator.setDefaults({
        onkeyup: false,
        ignore: ':hidden, .ignoreValidation, .addDepotItemValidation',
        onfocusout: (element, event) => {
            let isFromblzElem: boolean = $(element).is('#FromBlz');
            if (!isFromblzElem)
                $(element).valid()

            let isAutosuggestVisible: boolean = $('.ui-autocomplete').is(':visible');

            if (!isAutosuggestVisible)
                $(element).valid()

        }
    })



    $.extend($.validator.messages, {
        maxlength: jQuery.validator.format("Bitte geben Sie höchstens {0} Stellen an."),
        minlength: jQuery.validator.format("Bitte geben Sie mindestens {0} Stellen an.")
    });
})(jQuery);

